// extracted by mini-css-extract-plugin
module.exports = {"onHoldContainer":"membershipbadge_onHoldContainer__3C3PV","obliqueLineWrap":"membershipbadge_obliqueLineWrap__3Pk3D","obliqueLine":"membershipbadge_obliqueLine__1Drjz"};